import React from "react";
import { Empty } from "antd";

/**
 * Geschiedenis van een record als tijdlijn: bovenste gebeurtenis geaccentueerd,
 * daaronder de oudere in grijs. Scrollt binnen een vaste hoogte, zodat een
 * lange logboekstaart de rest van de pagina niet wegduwt.
 *
 * `items`: [{ key, text, meta }] — `text` mag JSX zijn (bijv. een link naar de
 * gekoppelde inkooporder).
 */
const ActivityTimeline = ({ items = [], maxHeight = 280, emptyText = "Nog geen activiteit" }) => {
  if (!items.length) {
    return (
      <div style={{ padding: "24px 20px" }}>
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={emptyText} />
      </div>
    );
  }

  return (
    <div style={{ padding: "18px 20px", maxHeight, overflowY: "auto" }}>
      {items.map((item, index) => {
        const last = index === items.length - 1;
        return (
          <div
            key={item.key ?? index}
            style={{ display: "grid", gridTemplateColumns: "18px minmax(0, 1fr)", gap: 12 }}
          >
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
              <span
                style={{
                  width: 8,
                  height: 8,
                  borderRadius: "50%",
                  background: index === 0 ? "#938370" : "#C9BFAF",
                  marginTop: 5,
                  flex: "none",
                }}
              />
              {last ? null : <span style={{ flex: 1, width: 1, background: "rgba(5, 5, 5, 0.08)" }} />}
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 3, paddingBottom: last ? 0 : 18 }}>
              <span style={{ fontSize: 13, lineHeight: 1.5 }}>{item.text}</span>
              {item.meta ? (
                <span
                  style={{
                    fontVariantNumeric: "tabular-nums",
                    fontSize: 12,
                    color: "rgba(0, 0, 0, 0.4)",
                  }}
                >
                  {item.meta}
                </span>
              ) : null}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ActivityTimeline;
